// extracted by mini-css-extract-plugin
export default {"container":"ProgressBarWidget_container__uaxyp","rangeFromProgress":"ProgressBarWidget_rangeFromProgress__kHgrm","containerOpened":"ProgressBarWidget_containerOpened__-olAw"};